import { PermissionGroupMessages, TranslationPermissionGroupMessages } from "../interfaces";

export const messages : TranslationPermissionGroupMessages = {
  [PermissionGroupMessages.generalRegistration]: "General registration",
  [PermissionGroupMessages.supply]: "Supply",
  [PermissionGroupMessages.concreteRecipeFamily]: "Concrete recipe family",
  [PermissionGroupMessages.administration]: "Administration",
  [PermissionGroupMessages.supplyQuality]: "Supply quality",
  [PermissionGroupMessages.vehicles]: "Vehicles",
  [PermissionGroupMessages.employees]: "Employees",
  [PermissionGroupMessages.report]: "Report",
  [PermissionGroupMessages.settings]: "Settings",
  [PermissionGroupMessages.expedition]: "Expedition",
  [PermissionGroupMessages.schedule]: "Schedule",
  [PermissionGroupMessages.userRightsControl]: "User rights control",
  [PermissionGroupMessages.batchPortalMaintenanceView]: "Maintenance Task View",
  [PermissionGroupMessages.batchPortalMaintenanceEdit]: "Maintenance Task Edit",
  [PermissionGroupMessages.batchPortalMaintenanceExecute]: "Maintenance Task Execute",
  [PermissionGroupMessages.batchPortalAutomationView]: "Automation View",
  [PermissionGroupMessages.batchPortalAutomationExecute]: "Automation Execute",
  [PermissionGroupMessages.batchPortalAutomationAdmin]: "Automation Admin",
  [PermissionGroupMessages.batchPortalAutomationSuperAdmin]: "Automation Super Admin",
  [PermissionGroupMessages.dashboard]: "Dashboard",
  [PermissionGroupMessages.laboratory]: "Laboratory"
};